import { Button, Typography } from "@mui/material";
import Grid from '@mui/material/Grid';
import { ShoppingCartWithItems } from 'common-models';
import { FC, useEffect, useState } from "react";
import { useGetOrderFromShoppingCartMutation, useGetShoppingCartQuery } from "../../features/events/eventShopApiSlice";
import { selectVisitor } from "../../features/visitor/visitorSlice";
// import swishLogo from '../../../images/swish-logo.jpg';

import { useNavigate } from "react-router-dom";
import SwishLogoPng from '../../images/swish-logo.png';
import { useAppSelector } from "../../state/hooks";
import PageIsLoading from "../PageIsLoading";
import { MiniCartItem } from "../Shop/MiniCartItem";
import { PaymentStepper } from "./PaymentStepper";

type CheckoutCartViewProps = {
    cartId: string,
}

const CheckoutCartView: FC<CheckoutCartViewProps> = ({ cartId }) => {
    const visitor = useAppSelector(selectVisitor);
    const nav = useNavigate();

    // API CALLS
    const { data = undefined as unknown as ShoppingCartWithItems } = useGetShoppingCartQuery([cartId, 'Open']);

    const [shoppingCart, setShoppingCart] = useState(undefined as unknown as ShoppingCartWithItems);
    const [getOrderFromShoppingCart, { data: orderId }] = useGetOrderFromShoppingCartMutation();

    useEffect(() => {
        if (data !== undefined) {
            setShoppingCart(data);
        }
    }, [data])

    useEffect(() => {
        if (orderId) {
            nav({ pathname: `/checkout/${orderId}` });
        }

    }, [nav, orderId])

    function getSumIncludingVat(input: number): number {
        return input * 1.25;
    }

    async function initiateSwishPayment() {
        const cartId: string = data.id;
        await getOrderFromShoppingCart(cartId);

    }

    return (
        <>
            <PaymentStepper currentStep={0} />

            {shoppingCart === undefined ? (
                <PageIsLoading />
            ) : (
                <Grid
                    container
                    className='cart-items-container'>
                    <Grid
                        size={{ xs: 12, md: 4 }}>
                        <Typography component={"h2"} variant="h2">
                            {" "}
                            Total: SEK {getSumIncludingVat(shoppingCart.totalSum)}
                        </Typography>
                        <Button onClick={initiateSwishPayment} variant='contained'>
                            {/* <img className={classes.swishLogo} src={swishLogo} alt="swish" /> */}
                            Betala med Swish <img src={SwishLogoPng} className='swish-logo' alt="Swish logo" />
                        </Button>
                        <Grid container>
                            Alla priser är i SEK inklusive moms.
                        </Grid>
                    </Grid>

                    <Grid
                        container
                        size={{ xs: 12, md: 8 }}>
                        <Typography component={"h2"} variant="h2">
                            {" "}
                            Dina bilder
                        </Typography>
                        <Grid container>
                            {
                                shoppingCart?.items.map(x => <MiniCartItem key={`mci-${x.id}`} cartItem={x} visitor={visitor} />)
                            }
                        </Grid>
                    </Grid>

                </Grid>

            )
            }
        </>
    );
    // }
};




export { CheckoutCartView };
